// Utility to fetch city service area data by county/city slug
import data from '../data/oakandstoneremodel_service_areas.json';

// Helper to slugify county/city names for URLs
export function slugify(str) {
  return str
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^a-z0-9-]/g, '');
}

// Get city data by county/city slug
export function getCityServiceAreaData(countySlug, citySlug) {
  return data.find(
    (entry) =>
      slugify(entry.County) === countySlug && slugify(entry.City) === citySlug
  );
}

// Get all city data
export function getAllCityServiceAreas() {
  return data;
}
